import { tryParseJSONObject } from '@fox/atoms';
import { CREATE_PERSON_BLOCK } from '../../../../form-block-types';
import { useFormRuntimeContext } from '../../../form-runtime-context';
import { QuestionDescriptionRender } from '../../question-block/question-description';
import { BUSINESS_ADDRESS_FIELD, BUSINESS_NAME_FIELD, CreatePersonBlockMetadata } from '../contracts';
import { getFieldOrder } from '../getFieldOrder';
import { CustomFieldLink } from '../shared-components/custom-field-link';
import { CustomFieldSelect } from '../shared-components/custom-field-select';
import { CustomFieldText } from '../shared-components/custom-field-text';
import { QuestionField } from '../shared-components/question-field';
import { getRenderField } from '../shared-components/render-fields';
import { updateAnswerForContact, updateBusinessDetailsForContact } from '../util';

type SinglePersonSectionProps = {
	id: string;
	currentAnswerSelections: any;
	currentAnswer: any;
	fieldProps: any;
	contact?: {
		id: string;
		[key: string]: string | boolean;
	};
};

export const SinglePersonSection = (props: SinglePersonSectionProps) => {
	const { currentAnswer, currentAnswerSelections, id, contact, fieldProps } = props;
	const { answerQuestion } = useFormRuntimeContext();

	const metaData = tryParseJSONObject<CreatePersonBlockMetadata>(fieldProps?.metadataJson, {});

	return (
		<div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
			{getFieldOrder(metaData)?.map(f => {
				const businessField = metaData.businessFields?.[f];
				if (businessField) {
					return (
						<div key={businessField.id}>
							<QuestionDescriptionRender
								id={id}
								required={businessField?.meta?.required}
								value={businessField.labelOverride ?? businessField.label}
							/>

							{businessField.type === 'select' ? (
								<CustomFieldSelect
									id={id}
									currentAnswer={currentAnswer}
									currentAnswerSelections={currentAnswerSelections}
									field={businessField}
									contactId={contact?.id}
									meta={businessField.meta ?? {}}
									questionType={CREATE_PERSON_BLOCK}
								/>
							) : null}

							{businessField.type === 'link' ? (
								<CustomFieldLink
									id={id}
									currentAnswer={currentAnswer}
									currentAnswerSelections={currentAnswerSelections}
									field={businessField}
									contactId={contact?.id}
									questionType={CREATE_PERSON_BLOCK}
									key={businessField.id}
								/>
							) : null}

							{businessField.type === 'string' ? (
								<CustomFieldText
									id={id}
									currentAnswer={currentAnswer}
									currentAnswerSelections={currentAnswerSelections}
									field={businessField}
									contactId={contact?.id}
									questionType={CREATE_PERSON_BLOCK}
								/>
							) : null}
						</div>
					);
				} else {
					const field = metaData.editFields?.[f];
					if (!field) return null;
					return (
						<QuestionField
							key={f}
							type={f}
							id={id}
							required={field.meta?.required}
							hideLabel={field.meta?.hideLabel}
							tabIndex={undefined}
							description={field.labelOverride ?? field.label}
							value={contact ? currentAnswerSelections?.contacts?.find(c => c.id === contact?.id)?.[f] : ''}
							onChange={c => {
								if (f.startsWith(BUSINESS_ADDRESS_FIELD) || f === BUSINESS_NAME_FIELD) {
									updateBusinessDetailsForContact(
										currentAnswer,
										currentAnswerSelections,
										contact?.id,
										answerQuestion,
										{ [f]: c, asAbove: false },
										CREATE_PERSON_BLOCK
									);
								} else {
									updateAnswerForContact(
										currentAnswer,
										currentAnswerSelections,
										contact?.id,
										answerQuestion,
										f,
										c,
										CREATE_PERSON_BLOCK
									);
								}
							}}
							meta={metaData}
							component={getRenderField(field.componentName)}
						/>
					);
				}
			})}
		</div>
	);
};
